import type { MeterImportParsedRow } from "@/lib/csv-parser";
import type { MeterImportRowErrors } from "@/lib/schemas/meter-import.schema";

export type MeterImportRow = MeterImportParsedRow & { _id: string };

let ridCounter = 0;
export function createRowId(): string {
	ridCounter += 1;
	return `r${Date.now().toString(36)}-${ridCounter}`;
}

export function makeEmptyRow(): MeterImportRow {
	return {
		_id: createRowId(),
		serial_number: "",
		encryption_key: "",
		type: "",
		street: "",
		apartment_number: "",
	};
}

export function makeRowFromParsed(row: MeterImportParsedRow): MeterImportRow {
	return { ...row, _id: createRowId() };
}

export type RowErrorsMap = Record<string, MeterImportRowErrors>;

export function findDuplicateSerials(rows: MeterImportRow[]): Set<string> {
	const counts = new Map<string, number>();
	for (const r of rows) {
		const sn = r.serial_number.trim();
		if (!sn) continue;
		counts.set(sn, (counts.get(sn) ?? 0) + 1);
	}
	const dups = new Set<string>();
	for (const [sn, c] of counts) if (c > 1) dups.add(sn);
	return dups;
}
